<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'service.survey-service.question-final-decision-statuses.revised.title' | translate }}</span>
    <span class="spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="close()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content>
  <div class="container my-3">
    <div class="original-statement-box">
      <div class="original-statement-label">{{ 'modals.modal-revise-question.original-statement' | translate }}</div>
      <div class="original-statement-text">{{ originalQuestion.question }}</div>
    </div>

    <div class="new-statement-label">
      <mat-icon>edit</mat-icon>
      {{ 'modals.modal-revise-question.new-statement' | translate }}
    </div>

    <!-- Stesso app-single-question usato nel builder della survey (in
         modalita' editabile, non risposta), cosi' tutti i campi della
         tipologia reale della domanda sono modificabili qui, non solo un
         sottoinsieme scelto a mano. Il suo stile "accordion" e'
         neutralizzato in scss: il contenitore visivo qui e' il dialog.
         isDeletable/clonable=false: non ha senso eliminare/duplicare una
         bozza di revisione non ancora salvata. -->
    <div class="single-question-wrapper">
      <app-single-question
        [question]="newQuestion"
        [survey]="data.survey"
        [isResponse]="false"
        [editable]="true"
        [isDeletable]="false"
        [clonable]="false">
      </app-single-question>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="dialog-actions-buttons">
  <button mat-stroked-button class="text-dark-purple border-purple mr-2" (click)="close()">{{ 'generic.cancel' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()"><mat-icon>save</mat-icon>{{ 'generic.buttons.save' | translate }}</button>
</mat-dialog-actions>
